import React from 'react';
import { useStoreContext } from '../../Contexts/StoreContext';
import Scrollbars from 'react-custom-scrollbars-2';
import CardStoreList from './CardStoreList';
import { formatCurrentAddress } from '../../Utils/Formatters';
import { TbMapPinQuestion, TbPencil } from 'react-icons/tb';
import { useTranslation } from 'react-i18next';

interface MultipleStoresFoundProps {
    stores: any;
    onHandleClick: CallableFunction,
    onCancel: CallableFunction,
}

const MultipleStoresFound = ({onHandleClick, onCancel, stores }: MultipleStoresFoundProps) => {

    const { t } = useTranslation();
    const { nextCurrentAddress } = useStoreContext();

    return (
        <div className="flex flex-col gap-4 pt-4 h-full">

            <div className='grid gap-4 text-center bg-white p-4 px-6'>
                <TbMapPinQuestion size={55} className='mx-auto text-shopfood-title' />
                <div className='grid place-items-center gap-0.5'>
                    <h2 className='text-2xl font-bold leading-none text-custom-primary'>{t('start.multiple_stores_found.title')}</h2>
                    <span className='text-xl font-bold text-shopfood-title'>{t('start.multiple_stores_found.subtitle')}</span>
                </div>

                { nextCurrentAddress && 
                    <div onClick={() => onCancel()} className="grid gap-1.5 leading-none mt-1 text-sm px-6 cursor-pointer">
                        <div className="flex items-center gap-0.5 justify-center font-semibold">{t('start.multiple_stores_found.edit_label')} <TbPencil /></div>
                        <span className="text-gray-400">{formatCurrentAddress(nextCurrentAddress)}</span>
                    </div>
                }
            </div>

            <Scrollbars autoHide={false} className='h-full w-full'>
                <div className="flex flex-col gap-4 h-full bg-gray-50 border-t border-gray-100 p-4">
                    {stores.map((store: any) =>
                        <CardStoreList onCardClick={() => onHandleClick(store)} store={store} key={`${store.id}`} />
                    )}
                </div>
            </Scrollbars>
        </div>
    )
}

export default MultipleStoresFound;